<template>
  <div>
    <v-overlay :value="invoiceGenerating">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <data-list
      :payload="listPayloadObj"
      :headers="headers"
      v-model="pagination"
      :total="total"
      :pagination="pagination"
      class="order_offer_table select_checkbox_column_width_0 select_checkbox_column_width_0_2ndcol"
      @change="paginationUpdated" @getTotalRecordsCount="debouncesGetPaginationCount">
      <template slot="expand">
        <v-progress-linear class="mt-1 mb-1" indeterminate v-if="materialsLoading"></v-progress-linear>
        <v-simple-table dense width="80%" class="dense_table bordered--table">
          <thead>
            <tr>
              <th v-for="(expandHeader, index) in expandHeader" :width="expandHeader.width" :key="index">{{expandHeader.text}}</th>
            </tr>
          </thead>
          <tbody v-for="(expandList, index) in listPayloadObj.expanded" :key="index">
            <template v-for="(product, i) in orderMaterials">
              <tr :key="`${i}_location`">
                <td width="20%">{{ product.number }}</td>
                <td width="50%">{{ product.producttext }}</td>
                <td width="10%">{{ product.qty | replaceDotWithComma }}</td>
                <td width="10%">{{ product.productunit_name }}</td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </template>
      <v-container fluid grid-list-xl slot="filterForm" class="pa-0">
        <v-layout>
          <v-flex class="ml-2">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  {{ $t('message.common.new') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in types.filter(x => x.value !== 'rest_order')" :key="index" :to="`/orders/actions?type=${item.value}${isCustomerSublist ? '&customerid='+moduleId : ''}`">
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex>
            <v-btn fab dark @click="exportOrders()" small color="success" :loading="exportLoading">
              <v-icon dark id="generateexcel">mdi-file-excel</v-icon>
            </v-btn>
          </v-flex>
          <v-flex>
            <v-switch v-model="showAll" color="primary" @change="debouncedGetSearchResults" inset :label="$t('message.order.myTasks')" class="ma-0"></v-switch>
          </v-flex>
          <v-flex>
            <v-autocomplete v-model="filterObj.type" multiple autocomplete="off" @change="deployedFilters(true)" :items="types" item-text="name" item-value="value" :label="$t('message.product.type')" dense hide-details outlined>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.name }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filterObj.type.length - 1 }} {{ $t('message.common.others') }})</span>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex  v-if="!isCustomerSublist">
            <v-autocomplete clearable v-model="filterObj.customerid" @change="deployedFilters(false)" autocomplete="off" :items="allCustomers" item-text="name" item-value="id" :label="$t('message.order.customer')" dense hide-details outlined :item-disabled="isCustomerDisabled">
              <template v-slot:item="{ item }">
                <span :style="{ color: item.isactive ? 'inherit' : '#ec1b1b' }">
                  {{ item.name }}
                </span>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete clearable v-model="filterObj.responsibleid" @change="deployedFilters(false)" autocomplete="off" :items="listOfUsers" item-text="fullname" item-value="id" :label="$t('message.deviations.responsible')" dense hide-details outlined ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete clearable v-model="filterObj.status" multiple @change="deployedFilters(false)" autocomplete="off" :items="filteredTypes" item-text="name" item-value="id" :label="$t('message.layout.status')" dense hide-details outlined>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.name }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filterObj.status.length - 1 }} {{ $t('message.common.others') }})</span>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex>
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="debouncedGetSearchResults" @click:append="debouncedGetSearchResults" outlined dense single-line :loading="searchLoading" v-model="search" :label="$t('message.common.search')" class="text-xs-right search-hint-padding" id="searchbtn"></v-text-field>
          </v-flex>
          <v-flex class="text-right mr-3 mt-2">
            <v-progress-linear v-if="listPayloadObj.loading" color="primary" indeterminate rounded height="6"></v-progress-linear>
            <b v-else>{{ totalPrice | replaceDotWithComma }}</b>
          </v-flex>
        </v-layout>
    </v-container>
    </data-list>
    <v-dialog v-model="shareDialog" persistent max-width="1150px" class="mt-0">
      <v-form ref="shareForm" onSubmit="return false;">
        <v-card>
          <v-card-title>
            <template v-if="orderModel.type === 'order'">
              {{ $t('message.order.sendOrderConfirmation').toLowerCase() }}
            </template>
            <template v-else-if="orderModel.type === 'offer'">
              {{ $t('message.order.sendOffer') }}
            </template>
            <template v-else-if="orderModel.type === 'sales'">
              {{ $t('message.order.sendSales') }}
            </template>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-autocomplete outlined dense name="contact" hide-details v-model="activeContact" @change="getEmailForContact"
                  :items="contactsList" item-text="name" item-value="id" :loading="loadingContacts"
                  :label="$t('message.orders.contact')">
                </v-autocomplete>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mails" ref="autoFocus" :rules="$_requiredValidation"
                  :label="$t('message.user.email')"
                  persistent-hint :hint="$t('message.common.add_extra_mails')"></v-text-field>
              </v-row>
              <v-row class="mt-4">
                <v-text-field outlined dense v-model="mail.subject" :rules="$_requiredValidation"
                  persistent-hint :hint="$t('message.tickets.subject')"></v-text-field>
              </v-row>
              <v-row>
                <!-- <v-textarea outlined textarea :label="$t('message.tickets.body')" v-model="mail.body" hide-details></v-textarea> -->
                <v-flex xs12>
                  <label class="subtitle-1">{{ $t('message.tickets.body') }}</label>
                  <ckeditor :editor="editor" v-model="mail.body" :config="configEditor"></ckeditor>
                </v-flex>
              </v-row>
              <v-row>
                <v-checkbox dense :label="$t('message.common.copy_to_me')" v-model="isCopyToMe" hide-details color="primary"></v-checkbox>
              </v-row>
              <v-row v-if="orderModel && orderModel.type !== 'sales'">
                <attach_share v-if="shareDialog" v-model="filelist" :filelist="filelist" :sharepoint="sharepointObj"></attach_share>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="sendMail" :loading="shareLoading" @click="shareReport">{{ $t('message.common.send') }}</v-btn>
            <v-btn color="error" id="close" @click="closeShareDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- Create REST order warning! -->
    <v-dialog v-model="restOrderObj.dialog" persistent width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('message.common.warning') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h2 class="mt-3">{{ $t('message.order.productsNotPicked') }}</h2>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="restOrderObj.withRestOrder()">
            {{ $t('message.order.invoiceWithRest') }}
          </v-btn>
          <v-btn color="primary" @click="restOrderObj.withoutRestOrder()">
            {{ $t('message.order.invoiceWithoutRest') }}
          </v-btn>
          <v-btn color="error" @click="restOrderObj.onCancel()">{{ $t('message.common.cancel') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Invoice creation failed warning -->
    <v-dialog v-model="invoiceIssueModal" persistent width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h3 class="mt-2">{{ $t('message.invoice.statusOfInvoices') }}</h3>
          <v-simple-table dense class="bordered--table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t('message.invoice.invoiceNumber') }}</th>
                  <th class="text-left">{{ $t('message.settings.order') }}</th>
                  <th class="text-left">{{ $t('message.common.status') }}</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in invoiceStatusList" :key="item.invoiceid">
                  <td>{{ item.invoicenumber || '' }}</td>
                  <td><router-link :to="`/orders/edit/${item.orderid}/view`">{{ item.ordernumber || '' }}</router-link></td>
                  <td>{{ item.status === 200 ? $t('message.invoice.success') : $t('message.invoice.failed') }}</td>
                  <td v-if="item.status === 500">{{ item.errormessage || '' }}</td>
                  <td v-else></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="invoiceIssueModal = false">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
import orderReport from '@/mixins/Order/report'
import packReport from '@/mixins/Order/packing_list'
import bulkInvoice from '@/mixins/Order/bulk_invoice'
import axios from 'axios'
import { getOrderTemplate, getOfferTemplate } from '@/constants'
import Editor from '@/ckeditor'
export default {
  props: ['fromModule', 'moduleId'],
  data () {
    return {
      exportLoading: false,
      filelist: [],
      debouncesGetPaginationCount: this.$formatter.debounce(this.getListCount, 500),
      debouncedGetSearchResults: this.$formatter.debounce(this.getListHandler, 500),
      listPayloadObj: {
        showCount: false,
        showNewFooter: true,
        totalLoading: false,
        hasNextPage: true,
        isHeader: true,
        isHideAdd: true,
        selection: [],
        hasFilters: true,
        showSelect: true,
        isOffer: true,
        addNewRoute: () => false,
        onExpand: ({ item }) => this.getOrderMaterials(item),
        list: [],
        loading: true,
        page: 1,
        expand: true,
        editProp: 'number',
        editURL: (item) => `/orders/edit/${item.id}/view`,
        changeState: this.createBulkInvoices,
        actionsList: [{
          click: (item) => this.printOrder(item),
          icon: () => 'mdi-arrow-down-bold-circle-outline',
          is_show: (item) => item.type !== 'sales'
        }, {
          click: (item) => this.sendReport(item),
          icon: () => 'mdi-email-variant',
          is_show: (item) => item.type !== 'sales'
        }, {
          click: (item) => this.downloadPackingList(item),
          icon: () => 'mdi-briefcase-download',
          is_show: (item) => item.type !== 'sales' && item.haspickedqty
        }, {
          click: (item) => this.deleteOrder(item),
          icon: () => 'mdi-trash-can-outline',
          is_show: (item) => item.candelete
        }]
      },
      total: 0,
      totalPrice: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.ORDER_INDEX) ? this.$store.state.ORDER_INDEX : { sortBy: ['number'], itemsPerPage: 25, sortDesc: [true], search: '' },
      MODULE: 'orders',
      state: this.$route.params.type,
      shareDialog: false,
      isCopyToMe: false,
      mails: '',
      orderModel: {},
      shareLoading: false,
      showAll: false,
      search: '',
      filterObj: {},
      orderMaterials: [],
      materialsLoading: false,
      companyName: '',
      invoiceGenerating: false,
      invoiceIssueModal: false,
      invoiceStatusList: [],
      searchLoading: false,
      loadingContacts: false,
      contactsList: [],
      filteredTypes: [],
      activeContact: 0,
      mail: { // for task #11760
        subject: '',
        body: ''
      },
      isCustomerSublist: false,
      editor: Editor,
      configEditor: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      },
      restOrderObj: {
        dialog: false
      },
      allCustomers: [],
      sharepointObj: {
        loading: false,
        files: []
      },
      sharepointId: '',
      settingsObj: {}
    }
  },
  components: {
    DataList,
    'attach_share': () => import('@/components/AttachFileToMail.vue')
  },
  computed: {
    ...mapState(['ORDER_INDEX', 'listOfUsers']),
    headers () {
      let list = [{
        text: this.$t('message.product.number'),
        value: 'number',
        width: '6%'
      }, {
        text: this.$t('message.product.type'),
        value: 'type_name',
        width: '6%'
      }, {
        text: this.$t('message.orders.salesReference'),
        value: 'salesreference',
        width: '11%'
      }, {
        text: this.$t('message.tickets.status'),
        value: 'state',
        width: '6%'
      }, {
        text: this.$t('message.order.customer'),
        value: 'customername',
        width: '11%'
      }, {
        text: this.$t('message.orders.contact'),
        value: 'contactname',
        width: '8%'
      }, {
        text: this.$t('message.orders.yourReference'),
        value: 'yourreference',
        width: '8%'
      }, {
        text: this.$t('message.deviations.responsible'),
        value: 'responsiblename',
        width: '9%'
      }, {
        text: this.$t('message.order.orderOffer'),
        value: 'orderdate',
        width: '7%'
      }, {
        text: this.$t('message.customer.delivery'),
        value: 'deliverydate',
        width: '7%'
      }, {
        text: this.$t('message.orders.totalExVat'),
        value: 'totalexvat',
        align: 'right',
        width: '7%'
      }, {
        text: this.$t('message.turnoverReport.dg'),
        value: 'dg',
        align: 'right',
        width: '5%'
      }, {
        text: this.$t('message.layout.order'),
        sortable: false,
        value: 'source_ref_number',
        width: '6%'
      }, {
        text: this.$t('message.tickets.actions'),
        sortable: false,
        value: 'actions',
        width: '100px'
      }]
      if (this.isCustomerSublist) list.splice(3, 1)
      return list
    },
    expandHeader () {
      return [ {
        text: this.$t('message.orders.productNo'),
        value: 'warehousename',
        width: '10%'
      }, {
        text: this.$t('message.customer.name'),
        value: 'locationname',
        width: '10%'
      }, {
        text: this.$t('message.product.orderQty'),
        value: 'oncustomerorder',
        width: '10%'
      }, {
        text: this.$t('message.product.unit'),
        value: 'onstock',
        width: '10%'
      }]
    },
    types () {
      return [{
        name: this.$t('message.layout.sales'),
        value: 'sales'
      }, {
        name: this.$t('message.layout.offer'),
        value: 'offer'
      }, {
        name: this.$t('message.layout.order'),
        value: 'order'
      }, {
        name: this.$t('message.orders.restOrder'),
        value: 'rest_order'
      }]
    },
    isCustomerExists () {
      const hasCustomer = this.allCustomers.find(x => x.id === this.filterObj.customerid)
      return !!hasCustomer
    }
  },
  watch: {
    search: function (newValue, oldValue) {
      if (!newValue) {
        this.listPayloadObj.loading = true
        this.debouncedGetSearchResults()
      }
    }
  },
  mixins: [orderReport, packReport, bulkInvoice],
  created () {
    this.getSettings()
  },
  mounted () {
    this.filterStatusByTypes()
    this.isCustomerSublist = this.fromModule === 'customers' && !!this.moduleId // Check if is customer list
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    // remember filter
    if (!this.$formatter.isEmptyObject(this.$store.state.F_ORDERS)) {
      let { filter } = this.$formatter.cloneVariable(this.$store.state.F_ORDERS)
      this.filterObj.status = filter.status || []
      this.filterObj.responsibleid = filter.responsibleid || 0
      this.filterObj.customerid = filter.customerid || 0
      this.filterObj.type = filter.type || []
      this.search = filter.search || ''
      this.showAll = filter.showAll || false
    }
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.debouncedGetSearchResults()
        this.$eventBus.$emit('reRenderOrderModule')
      }
    })
    this.$store.dispatch('getAllCustomersIncludingInactive')
      .then((customers) => {
        this.allCustomers = customers || []
      })
    this.$store.dispatch('getUsers')
    this.getInvoiceSettings()
    if (this.isCustomerSublist) this.filterObj.customerid = +this.moduleId
  },
  methods: {
    paginationUpdated (val) {
      let model = { type: 'ORDER_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.debouncedGetSearchResults()
    },
    getListCount () {
      this.listPayloadObj.totalLoading = true
      const getIds = this.$route.query.ids || null
      let model = {
        search: this.search,
        status: this.filterObj.status || [],
        responsibleid: this.filterObj.responsibleid || 0,
        customerid: this.filterObj.customerid || 0,
        type: this.filterObj.type || [],
        ids: getIds ? JSON.parse(getIds) : [],
        showAll: this.showAll
      }
      let userId = this.$store.state.userDetails.id !== -100 ? this.$store.state.userDetails.id : 0
      if (this.showAll) model.responsibleid = userId
      this.$_executeApi('post', `orders/get_paginate_filter_count`, model).then(({ data: total }) => {
        this.total = total
        this.listPayloadObj.showCount = true
      }).finally(() => {
        this.listPayloadObj.totalLoading = false
      })
    },
    deployedFilters (isType) {
      this.$set(this.pagination, 'page', 1)
      this.$set(this.pagination, 'hideCount', true)
      this.$set(this.listPayloadObj, 'showCount', false)
      this.debouncedGetSearchResults()
      if (isType) this.filterStatusByTypes()
    },
    filterStatusByTypes () {
      const status = this.$_orderOfferStatus
      const types = this.filterObj.type
      var list = status
      if (types && types.length > 0) {
        list = status.filter(x => types.includes(x.value))
      }
      this.filteredTypes = list
    },
    getListHandler () {
      this.listPayloadObj.loading = true
      this.searchLoading = true
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let sortByValue = ''
      if (sortBy && sortBy[0] && sortBy[0] === 'type_name') sortByValue = 'type'
      else if (sortBy && sortBy[0]) sortByValue = sortBy[0]
      const getIds = this.$route.query.ids || null
      let model = {
        descending: sortDesc && sortDesc[0],
        page,
        sortby: sortByValue,
        search: this.search,
        rowsperpage: itemsPerPage,
        status: this.filterObj.status || [],
        responsibleid: this.filterObj.responsibleid || 0,
        customerid: this.filterObj.customerid || 0,
        type: this.filterObj.type || [],
        ids: getIds ? JSON.parse(getIds) : [],
        showAll: this.showAll
      }
      let data = { type: 'F_ORDERS', data: { filter: model } }
      this.$store.commit('rememberFilter', data)
      /* Added to store search in pagination */
      let paginationModel = this.$formatter.cloneVariable(this.pagination)
      paginationModel.search = this.search
      let pModel = { type: 'ORDER_INDEX', data: paginationModel }
      this.$store.commit('rememberOrder', pModel)
      /**/
      let userId = this.$store.state.userDetails.id !== -100 ? this.$store.state.userDetails.id : 0
      if (this.showAll) model.responsibleid = userId
      this.$_executeApi('post', 'orders/paginate_filter', model)
        .then((response) => {
          let { items, hasnextpage } = response.data
          this.listPayloadObj.loading = false
          // let transformData = { date: { list: ['orderdate', 'offerdatesent', 'offerdate', 'salesdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
          //   number: { list: ['totalsum', 'totalexvat', 'totalvat', 'salesvalue', 'dg'], format: 'replaceDotWithComma' } }
          let model = items // this.$_formatListModel(items, transformData)
          model.map(x => {
            x.orderdate = this.$formatter.formatDate(x.orderdate, 'DD.MM.YYYY', 'DD.MM.YYYY')
            x.offerdatesent = this.$formatter.formatDate(x.offerdatesent, 'DD.MM.YYYY', 'DD.MM.YYYY')
            x.offerdate = this.$formatter.formatDate(x.offerdate, 'DD.MM.YYYY', 'DD.MM.YYYY')
            x.salesdate = this.$formatter.formatDate(x.salesdate, 'DD.MM.YYYY', 'DD.MM.YYYY')
            x.deliverydate = this.$formatter.formatDate(x.deliverydate, 'DD.MM.YYYY', 'DD.MM.YYYY')
            x.totalsum = this.$formatter.replaceDotWithComma(x.totalsum)
            x.totalexvat = this.$formatter.replaceDotWithComma(x.totalexvat)
            x.totalvat = this.$formatter.replaceDotWithComma(x.totalvat)
            x.salesvalue = this.$formatter.replaceDotWithComma(x.salesvalue)
            x.dg = this.$formatter.replaceDotWithComma(x.dg)
            x.status = x.state
            if (x.type === 'sales') {
              x.totalexvat = x.salesvalue
              x.orderdate = x.salesdate
            } else if (x.type === 'offer') {
              if (x.offerdatesent === '01.01.0001') {
                x.orderdate = x.offerdate
              } else x.orderdate = x.offerdatesent
            }
            const getStatusName = this.getStatusName(x.state)
            x.state = getStatusName ? getStatusName.name : x.state
            const getType = this.getTypeName(x.type)
            // x.salesreference = x.salesreference && x.salesreference.split(' ').length ? x.salesreference.split(' ')[0] : ''
            x.type_name = getType ? getType.name : x.type
            if (x.restcreatedfrom && x.restcreatedfrom > 0) {
              const restDetails = [{ Id: x.restcreatedfrom, Number: x.restcreatedfromnumber }]
              x.rest_ref_number = restDetails
            }
            const relatedOrders = []
            const alreadyAddedId = []
            x.source_ref_number = x.source_ref_number ? JSON.parse(x.source_ref_number) : []
            x.source_ref_number_1 = x.source_ref_number_1 ? JSON.parse(x.source_ref_number_1) : []
            x.sales_ref_number = x.sales_ref_number ? JSON.parse(x.sales_ref_number) : []
            x.offer_sharepoint = x.offer_sharepoint ? JSON.parse(x.offer_sharepoint) : []
            if (!x.rest_ref_number) x.rest_ref_number = []
            const mergedData = [...x.source_ref_number, ...x.sales_ref_number, ...x.rest_ref_number, ...x.source_ref_number_1]
            mergedData.map(y => {
              if (!alreadyAddedId.includes(y.Id)) {
                relatedOrders.push(y)
                alreadyAddedId.push(y.Id)
              }
            })
            x.related_orders = relatedOrders
            return x
          })
          this.listPayloadObj.state = model.state
          this.total = itemsPerPage
          this.totalPrice = this.$_getSumBy(model, x => x.totalexvat)
          this.listPayloadObj.selection = []
          this.listPayloadObj.hasNextPage = hasnextpage
          this.listPayloadObj.list = model
          this.$set(this.pagination, 'hideCount', true)
          this.$set(this.listPayloadObj, 'showCount', false)
        })
        .finally(() => {
          this.searchLoading = false
        })
    },
    getOrderMaterials (item) {
      this.materialsLoading = true
      this.orderMaterials = []
      this.$_executeApi('get', `ordermaterials/get_materials_for_orderlist/${item.id}`)
        .then((response) => {
          this.orderMaterials = response.data
        })
        .finally(() => {
          this.materialsLoading = false
        })
    },
    deleteOrder (item) {
      let payload = { ids: [item.id], url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
      this.$store.commit('showDeleteDialog', payload)
    },
    async printOrder (item) {
      this.listPayloadObj.loading = true
      const getTypeObj = this.getTypeName(item.type)
      this.getOrderDetailedView(item.id)
        .then(async (reportData) => {
          this.$_executeApi('post', `orders/generate_pdf/${item.id}/2/download`, { visiblefilename: `${getTypeObj ? getTypeObj.name + '_' : ' '}${item.number}`, content: await this.genereateReportContent(reportData) })
            .then((response) => {
              let fileName = response.data
              window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
            })
            .finally(() => {
              this.listPayloadObj.loading = false
            })
        })
    },
    async downloadPackingList (item) {
      this.listPayloadObj.loading = true
      this.getOrderDetailedView(item.id)
        .then(async (reportData) => {
          this.$_executeApi('post', `orders/generate_packing_report/${item.id}/packlist/download`, { visiblefilename: `Pakkseddel_${item.number}`, content: await this.genereatePackReportContent(reportData) })
            .then((response) => {
              let fileName = response.data
              window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
            })
            .finally(() => {
              this.listPayloadObj.loading = false
            })
        })
    },
    async sendReport (item) {
      this.activeContact = item.contactid
      this.getContacts(item)
      this.shareDialog = true
      this.mails = item.contactemail || ''
      this.orderModel = item
      /* Set template data */
      const { mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
      if (this.orderModel.type === 'offer') {
        const offerEmailTemplate = getOfferTemplate(this.orderModel)
        this.mail.subject = offerEmailTemplate.subject
        this.mail.body = `${offerEmailTemplate.body} ${mail_signature}`
      } else {
        const orderEmailTemplate = getOrderTemplate('Ordrebekreftelse', this.orderModel)
        this.mail.subject = orderEmailTemplate.subject
        this.mail.body = `${orderEmailTemplate.body} ${mail_signature}`
      }
      // get sharepoint docs to be shared
      this.sharepointId = item.sharepoint_id
      this.sharepointObj.files = []
      this.filelist = []
      const childSpId = item.offer_sharepoint[0] ? item.offer_sharepoint[0].SharePoint_Id || 0 : 0
      if (this.sharepointId) this.getAllDocumentsFromSharepoint(this.sharepointId, childSpId)
    },
    getInvoiceSettings () {
      this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    getOrderDetailedView (orderId) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `orders/get_detail_view/${orderId}`)
          .then((result) => {
            let transformData = { date: { list: ['orderdate', 'offerdate', 'deliverydate', 'salesdate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
              number: { list: ['totalsum', 'totalexvat', 'totalvat', 'salesvalue', 'dg'], format: 'replaceDotWithComma' } }
            let model = this.$_formatModel(result.data, transformData)
            resolve(model)
          })
          .catch((ex) => {
            reject(ex)
          })
      })
    },
    async shareReport () {
      if (this.$refs.shareForm.validate()) {
        this.shareLoading = true
        if (!this.mails.length > 0) this.isValidEmail = true
        let getMailIDsString = this.mails
        let listOfMailIds = getMailIDsString.split(',')
        if (listOfMailIds && listOfMailIds.length > 0) {
          for (let i = 0; i < listOfMailIds.length; i++) {
            if (listOfMailIds[i]) {
              listOfMailIds[i] = listOfMailIds[i].trim()
              this.validEmail(listOfMailIds[i]) ? this.isValidEmail = false : this.isValidEmail = true
            }
          }
        }
        if (!this.isValidEmail) {
          let currentUserMail = this.$store.state.userDetails ? this.$store.state.userDetails.email : ''
          this.shareLoading = true
          const getTypeObj = this.getTypeName(this.orderModel.type)
          const visibleFileName = `${getTypeObj ? getTypeObj.name : ''}_${this.orderModel.number}`
          // const body = this.mail.body.replace(/\n/g, '<br/>')
          this.getOrderDetailedView(this.orderModel.id)
            .then(async (reportData) => {
              this.$_executeApi('post', `orders/generate_pdf/${this.orderModel.id}/2/share`, { visiblefilename: visibleFileName, content: await this.genereateReportContent(reportData) })
                .then(async (response) => {
                  let fileName = response.data

                  // if type is OFFER/ORDER
                  if (this.orderModel && this.orderModel.type !== 'sales') {
                    // upload files to local for share attachments
                    const formData = new FormData()
                    const files = this.filelist
                    files.forEach(file => {
                      if (!file.is_sharepoint) {
                        formData.append(file.name, file)
                      } else {
                        formData.append(file.id, file)
                      }
                    })
                    await this.$_executeApi('post', `warehouseorders/attachment_upload/${this.orderModel.id}/ORDER_OFFER`, formData)
                  }

                  let model = { subject: this.mail.subject, body: this.mail.body, to: listOfMailIds, cc: this.isCopyToMe && currentUserMail ? [currentUserMail] : [], filename: fileName }
                  this.$_executeApi('post', `${this.MODULE}/share/${this.orderModel.id}`, model)
                    .then((response) => {
                      this.closeShareDialog()
                      this.shareLoading = false
                      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.tickets.sentSuccess') })
                    })
                })
                .catch(() => {
                  this.shareLoading = false
                })
            })
        } else {
          this.shareLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    closeShareDialog () {
      this.mails = ''
      this.shareDialog = false
      this.orderModel = {}
    },
    async createBulkInvoices (ids) {
      this.invoiceGenerating = true
      let model = { ids }
      this.$_executeApi('post', '/invoices/can_create_rest_order', model)
        .then((response) => {
          if (response && response.data) {
            this.restOrderObj = {
              dialog: true,
              withRestOrder: () => {
                this.makeBulkInvoice(ids, true)
                this.restOrderObj.dialog = false
              },
              withoutRestOrder: () => {
                this.makeBulkInvoice(ids, false)
                this.restOrderObj.dialog = false
              },
              onCancel: () => {
                this.restOrderObj.dialog = false
                this.invoiceGenerating = false
              }
            }
          } else {
            this.makeBulkInvoice(ids, false)
          }
        })
    },
    async makeBulkInvoice (ids, createRestOrder = false) {
      const getContent = await this.exportToMultiInvoices(ids, createRestOrder)
      this.$_executeApi('post', `/invoices/save_bulk_invoices?createRestOrder=${createRestOrder}`, getContent)
        .then((response) => {
          this.invoiceIssueModal = true
          this.invoiceStatusList = response.data
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.invoice.invoicesCreated') })
          this.debouncedGetSearchResults()
        })
        .finally(() => {
          this.invoiceGenerating = false
        })
    },
    getStatusName (state) {
      return this.$_findValueInArray(this.$_orderOfferStatus, x => x.id === state)
    },
    getTypeName (type) {
      return this.$_findValueInArray(this.types, x => x.value === type)
    },
    getSettings () {
      this.$_executeApi('get', 'commonsettings').then(response => {
        let { partyname } = response.data
        this.companyName = partyname
      })
    },
    getEmailForContact () {
      let getContact = this.contactsList.find(x => x.id === this.activeContact)
      if (getContact) {
        this.mails = getContact.email
      }
    },
    getContacts (item) {
      this.contactsList = []
      this.loadingContacts = true
      let query = { filter: `customer_id eq ${item.customerid}` }
      this.$_executeApi('post', `contacts/query`, query)
        .then(response => {
          let list = response.data
          list.map(x => {
            x.name = `${x.firstname || ''} ${x.lastname || ''}`
            return x
          })
          this.contactsList = list
        })
        .finally(() => {
          this.loadingContacts = false
        })
    },
    exportOrders () {
      this.exportLoading = true
      let model = {
        type: this.filterObj.type || [],
        customerid: this.filterObj.customerid || 0,
        responsibleid: this.filterObj.responsibleid || 0,
        status: this.filterObj.status || [],
        search: this.search
      }
      let userId = this.$store.state.userDetails.id !== -100 ? this.$store.state.userDetails.id : 0
      if (this.showAll) model.responsibleid = userId
      this.$_executeApi('post', 'orders/geneate_order_xlsx', model).then((response) => {
        this.$_downloadExportedReport(response.data).then(() => { this.exportLoading = false })
      })
    },
    /* eslint-disable */
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    getAllDocumentsFromSharepoint (id, childIds) {
      this.sharepointObj.loading = true
      this.$_executeApi('post', `sharepoint/get_multiple_sp_docs/${id}`, childIds ? [childIds || 0] : [])
        .then((response) => {
          if (response) {
            let { childrenfolderitems, parentfolderitems } = response.data
            childrenfolderitems = childrenfolderitems.filter(x => x.is_document)
            parentfolderitems = parentfolderitems.filter(x => x.is_document)
            this.sharepointObj.files = [...parentfolderitems, ...childrenfolderitems]
          }
        })
        .finally(() => {
          this.sharepointObj.loading = false
        })
    },
    isCustomerDisabled (item) {
      return !item.isactive
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    // before destroy if isCustomerExists is false, then we need to remove the customerid from filterObj and update the store with remaining data
    if (!this.isCustomerExists) {
      this.filterObj.customerid = 0
      let model = {
        filter: {
          search: this.search,
          status: this.filterObj.status || [],
          responsibleid: this.filterObj.responsibleid || 0,
          customerid: this.filterObj.customerid || 0,
          type: this.filterObj.type || [],
          showAll: this.showAll
        }
      }
      let data = { type: 'F_ORDERS', data: model }
      this.$store.commit('rememberFilter', data)
    }
  }
}
</script>
<style>
  .order_offer_table .v-data-table td, .order_offer_table .v-data-table th {
    padding: 0 6px !important;
  }
</style>
